export const isFwbEnabled = () => process.env.REACT_APP_FEATURE_FLAG_FWB === "true";
export const isFwmiEnabled = () => process.env.REACT_APP_FEATURE_FLAG_FWMI === "true";
export const isRenewalPolicyEnabled = () => process.env.REACT_APP_FEATURE_FLAG_RENEWAL_POLICY === "true";
export const isFwmiRenewalEnabled = () => process.env.REACT_APP_FEATURE_FLAG_FWMI_RENEWAL_POLICY === "true";
export const isHKHomeGuardEnabled = () => process.env.REACT_APP_FEATURE_FLAG_HK_HOME_GUARD === "true";
export const isHomeProtectorEnabled = () => process.env.REACT_APP_FEATURE_FLAG_HOMEPROTECTOR === "true";
